import React, { useContext } from "react";
import {FormattedMessage, useIntl} from "react-intl";

import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";

import LookAiPopupContext from "./LookAiPopupContext";
import {IS_QKB_UI} from "../../../../config";
import {getCurrentLayout} from "../../../appLayout";
import {hideGroupObject} from "../../aiFunctions";
import {getFeatureGroupName} from "../../../../misc/helpers";
import {useAppSelector} from "../../../../storeHooks";


const LookAIPopupFeatureGroups = (props) => {

  const {setLookAiExportData} = props;

  const {lookAiPopupContext, lookAiPopupDispatch} = useContext(LookAiPopupContext);
  const {groupObjects} = lookAiPopupContext;

  const intl = useIntl();
  const fabricatorData = useAppSelector(state => state.fabricatorState);

  const onSwitchClick = (groupObject) => (e) => {
    // e is a MouseEvent here -> altKey is reliable
    const isAlt = e.altKey === true;

    // optional: prevent MUI/input from toggling itself independently
    // (since we're fully controlling checked from state)
    e.preventDefault();
    e.stopPropagation();

    const newGroupObjects = isAlt
      // invert ALL
      ? groupObjects.map((go) => ({ ...go, enabled: !groupObject.enabled }))
      // invert ONE
      : groupObjects.map((go) =>
        go.partId === groupObject.partId ? { ...go, enabled: !go.enabled } : go
      );

    lookAiPopupDispatch({ groupObjects: newGroupObjects });
    setLookAiExportData(newGroupObjects);

    const layout = getCurrentLayout();
    layout.updateLocalStorage();
  };

  return (
    <div className="flex flex--column look-ai__content-groups" id="look-ai__panel-feature-groups">
      <div className="mt-0 mb-1 flex flex--column flex--top w-full">
        <p className={"m-0 bold" + (IS_QKB_UI ? " color-primary" : "")}>
          <FormattedMessage id="look.ai.panel.generateItems"/>
        </p>
        <p className="m-0 font--12 leading-1 look-ai__panel-text">
          <FormattedMessage id="look.ai.panel.generateItemsText"/>
        </p>
      </div>

      <ul className="m-0 p-0 w-full">
        {groupObjects
          ? groupObjects.map((groupObject) => {
            if (hideGroupObject(groupObject)) return null;
            return (
              <li key={groupObject.featureGroup.partId} className="mb-025">
                <FormControlLabel
                  style={{ color: "#66778D" }}
                  label={getFeatureGroupName(groupObject.featureGroup, intl, fabricatorData)}
                  className="m-0"
                  control={
                    <Switch
                      checked={groupObjects.some(gr => gr.partId === groupObject.partId && gr.enabled)}
                      className="gm-ios-checkbox"
                      disableRipple
                      onClick={onSwitchClick(groupObject)}
                      // keep onChange as a no-op (or omit it) so click is the single source of truth
                      onChange={() => {}}
                      color="primary"
                    />
                  }
                />
              </li>
            );
          })
          : null}
      </ul>
    </div>
  );
};

export default LookAIPopupFeatureGroups;
